<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15E/4B15E.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4B15E 1.5T Hybrid-Dedicated Gasoline Engine</div>
        <div class="detail-banner-desc">
          The 4B15E is a new‑generation 1.5T high‑thermal‑efficiency gasoline engine specifically designed for hybrid applications. It adopts an all‑new hybrid combustion architecture, is paired with a DHT (Dedicated Hybrid Transmission), and is suitable for sedans, SUVs, and MPVs；<br />
          Incorporating multiple innovative technologies, the engine is more advanced, delivers stronger power, and achieves lower fuel consumption.
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Parameters</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum power</div>
          <div class="detail-utils-u">123kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum torque</div>
          <div class="detail-utils-u">243N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Thermal efficiency</div>
          <div class="detail-utils-u">41.5%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission standard</div>
          <div class="detail-utils-u">China 6b</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Technologies</div>

      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">LP‑EGR System</div>
          <div class="detail-four-desc">
            The Exhaust Gas Recirculation (EGR) system recirculates combusted exhaust gases into the cylinders, increasing the heat capacity of the in‑cylinder mixture and lowering combustion temperature. This reduces NOₓ emissions. Lower combustion temperature also mitigates knocking, and the reduced knocking tendency allows for a higher compression ratio, improving fuel economy. Reduced combustion temperature also lowers exhaust temperature, expands the equivalent air‑fuel ratio operating window, and reduces CO emissions.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Miller Cycle + Variable Geometry Turbocharger (VGT)</div>
          <div class="detail-four-desc">
            The Miller cycle closes the intake valve early, making the expansion ratio greater than the compression ratio. This maximizes the conversion of thermal energy into mechanical work during the expansion stroke while reducing pumping losses at part load, thereby lowering fuel consumption.<br />
            To match the Miller cycle and achieve high‑speed performance, a Variable Geometry Turbocharger (VGT) is employed. With material upgrades, its temperature resistance is increased to 980°C, avoiding enrichment for component protection at full load and enabling λ=1 operation.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">350-bar Central Direct Injection</div>
          <div class="detail-updown-desc">
            The center-mounted injector reduces fuel wall-wetting and avoids oil dilution. The 350bar fuel injection system effectively reduces fuel spray diameter and accelerates fuel atomization. It enables triple injection, thereby reducing PN (particulate number) emissions.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">Electric Water Pump + Electric Thermostat</div>
          <div class="detail-updown-desc">
            To meet cooling demands, a 400‑W electric water pump provides on‑demand cooling, reducing energy consumption. Paired with an electric thermostat for fast response and precise coolant temperature control, it enables full‑map water temperature management, offering a more flexible thermal‑management strategy.<br />
            This effectively speeds up engine warm‑up and reduces heat‑transfer losses. Under low‑load conditions with minimal flow requirements, the pump can run at reduced speed to save energy. Under full‑load conditions, it provides stronger cooling capacity, accommodating special operating scenarios such as vehicle thermal stress, hill‑climbing, and sudden stops.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4B15E/4B15E-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box ">
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">Cylinder‑Head‑Integrated Exhaust Manifold</div>
            <div class="detail-tab-desc">
              This design reduces part count and cuts overall engine weight by 23%, making the overall engine structure more compact and lighter. During cold starts, it accelerates coolant warm‑up, improving engine pre‑heating performance, reducing exhaust‑energy loss, and shortening the time to reach optimal operating temperature. This effectively lowers the engine’s fuel‑consumption rate and emissions.
            </div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">Variable Displacement Oil Pump</div>
            <div class="detail-tab-desc">
              It can adjust oil pressure based on engine speed and load, reducing fuel consumption by 0.5% to 2%. Under high‑speed conditions, fuel consumption can be reduced by up to 3%.
            </div>
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              23%
            </div>
            <div class="detail-swiper-d">
              Weight reduction
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              0.5%～2%
            </div>
            <div class="detail-swiper-d">
              Engine fuel consumption rate reduction
            </div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15E/4B15E-5.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/4B15E/4B15E-6.jpg" alt=""></div>
        </div>
      </div>
    </div>

    
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4B15E 1.5T Hybrid-Dedicated Gasoline Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4B15E.html'
};

import { createApp } from 'vue';
import App from './4B15E.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4B15E.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>